import type { SVGProps } from 'react'

interface MagnifyingGlassIconProps extends SVGProps<SVGSVGElement> {}

export function MagnifyingGlassIcon(props: MagnifyingGlassIconProps) {
  return (
    <svg
      width={49}
      height={49}
      viewBox="0 0 49 49"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M32.987 26.242a14.786 14.786 0 01-13.431 8.546c-3.8 0-7.6-1.445-10.496-4.334-5.78-5.791-5.78-15.204 0-20.984a14.745 14.745 0 0110.495-4.348 14.72 14.72 0 0110.49 4.349c.343.344.635.676.906 1.008h5.474a19.534 19.534 0 00-3.185-4.206A19.213 19.213 0 0019.555.6 19.239 19.239 0 005.863 6.273c-7.544 7.543-7.543 19.825 0 27.378 6.31 6.3 16.343 7.455 23.892 2.767.027-.022.047-.052.078-.071a19.095 19.095 0 006.111-6.111c.008-.014.022-.021.031-.034a18.774 18.774 0 001.882-3.96h-4.87zM41.992 48.455a6.026 6.026 0 004.283-1.776 6.027 6.027 0 001.777-4.285c0-1.619-.63-3.142-1.777-4.289-1.27-1.27-5.36-4.234-9.39-6.412l-.016.022c-.077.111-.142.22-.223.332-.187.289-.43.599-.673.908-.02.025-.05.062-.073.084-.056.072-.124.147-.183.22l-.05.06c-.378.462-.794.932-1.24 1.374a.78.78 0 01-.068.077 19.89 19.89 0 01-1.45 1.306l-.05.042c-.094.077-.186.16-.28.235-.423.34-.85.648-1.285.946 2.178 4.028 5.14 8.11 6.408 9.38a6.02 6.02 0 004.286 1.776h.004z"
        fill="currentColor"
      />
      <path
        d="M39.62 15.832h-2.817a.129.129 0 00-.128.128v4.799c0 .071.058.129.128.129h2.817a.129.129 0 00.128-.13V15.96a.129.129 0 00-.128-.128zM26.574 15.832h-2.817a.129.129 0 00-.13.128v4.799c0 .071.059.129.13.129h2.817a.129.129 0 00.128-.13V15.96a.129.129 0 00-.128-.128z"
        fill="currentColor"
      />
      <path
        d="M15.898 10.48h12.904a13.14 13.14 0 00-9.247-3.774c-3.541 0-6.871 1.379-9.376 3.884-5.162 5.163-5.162 13.571 0 18.744 5.173 5.163 13.583 5.162 18.744 0a13.291 13.291 0 002.307-3.092H15.898a2.83 2.83 0 01-2.826-2.827V13.306a2.83 2.83 0 012.826-2.826z"
        fill="currentColor"
      />
      <path
        d="M48.721 23.415V13.306c0-.686-.557-1.243-1.244-1.243H15.898c-.685 0-1.243.557-1.243 1.243v10.109c0 .686.558 1.244 1.243 1.244h31.58c.686 0 1.243-.558 1.243-1.244zm-29.287-1.734a.792.792 0 01-1.584 0v-6.64a.792.792 0 011.584 0v6.64zm8.851-.922c0 .944-.768 1.712-1.712 1.712h-2.817a1.714 1.714 0 01-1.712-1.712V15.96c0-.943.768-1.711 1.712-1.711h2.817c.944 0 1.712.768 1.712 1.711v4.799zm4.194.922a.792.792 0 01-1.583 0v-6.64a.792.792 0 011.583 0v6.64zm8.852-.922c0 .944-.768 1.712-1.712 1.712h-2.817a1.714 1.714 0 01-1.71-1.712V15.96c0-.943.767-1.711 1.71-1.711h2.817c.944 0 1.712.768 1.712 1.711v4.799zm4.194.922a.792.792 0 01-1.583 0v-6.64a.792.792 0 011.583 0v6.64z"
        fill="currentColor"
      />
    </svg>
  )
}
